import { render } from "./CollectNumber.vue?vue&type=template&id=346fad54&scoped=true"
import script from "./CollectNumber.vue?vue&type=script&lang=js"
export * from "./CollectNumber.vue?vue&type=script&lang=js"

import "./CollectNumber.vue?vue&type=style&index=0&id=346fad54&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1ac9e6a1-3d63-42f4-aa32-2a0557ce8f53/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346fad54"]])

export default __exports__